export default __webpack_public_path__ + "static/media/eth_sm.b418dcd6.svg";